/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerSourceAllowNamesResponse } from './FindAllScreenerSourceAllowNamesResponse';
import {
    FindAllScreenerSourceAllowNamesResponseFromJSON,
    FindAllScreenerSourceAllowNamesResponseFromJSONTyped,
    FindAllScreenerSourceAllowNamesResponseToJSON,
    FindAllScreenerSourceAllowNamesResponseToJSONTyped,
} from './FindAllScreenerSourceAllowNamesResponse';

/**
 * 
 * @export
 * @interface FindAllSourceAllowNames200Response
 */
export interface FindAllSourceAllowNames200Response {
    /**
     * 
     */
    data?: FindAllScreenerSourceAllowNamesResponse;
}

/**
 * Check if a given object implements the FindAllSourceAllowNames200Response interface.
 */
export function instanceOfFindAllSourceAllowNames200Response(value: object): value is FindAllSourceAllowNames200Response {
    return true;
}

export function FindAllSourceAllowNames200ResponseFromJSON(json: any): FindAllSourceAllowNames200Response {
    return FindAllSourceAllowNames200ResponseFromJSONTyped(json, false);
}

export function FindAllSourceAllowNames200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceAllowNames200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllScreenerSourceAllowNamesResponseFromJSON(json['data']),
    };
}

export function FindAllSourceAllowNames200ResponseToJSON(json: any): FindAllSourceAllowNames200Response {
    return FindAllSourceAllowNames200ResponseToJSONTyped(json, false);
}

export function FindAllSourceAllowNames200ResponseToJSONTyped(value?: FindAllSourceAllowNames200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllScreenerSourceAllowNamesResponseToJSON(value['data']),
    };
}

